import _ from 'lodash'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { TweenMax, CSSPlugin, TimelineMax, Expo } from 'gsap/all'
const gsapPlugins = [ TweenMax, CSSPlugin, TimelineMax, Expo ]

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
